import React, { useEffect, useState, useRef } from 'react';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

// Safely parse a "YYYY-MM-DD" string to a local Date object
const parseDate = (str) => {
  if (!str) return null;
  const [year, month, day] = str.split('-');
  return new Date(Number(year), Number(month) - 1, Number(day));
};

// Format a Date to "YYYY-MM-DD"
const formatDate = (date) => {
  if (!date) return '';
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export default ({ value, onChange, ...props })=> {
  const [selectionRange, setSelectionRange] = useState({
    startDate: parseDate(value?.startDate),
    endDate: parseDate(value?.endDate),
    key: 'selection',
  });

  const [showPicker, setShowPicker] = useState(false);
  const pickerRef = useRef(null);

  useEffect(() => {
    setSelectionRange({
      startDate: parseDate(value?.startDate),
      endDate: parseDate(value?.endDate),
      key: 'selection',
    });
  }, [value]);

  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setSelectionRange(ranges.selection);

    onChange?.({
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
    });

    if (
      startDate &&
      endDate &&
      startDate.getTime() !== endDate.getTime()
    ) {
      setShowPicker(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target)) {
        setShowPicker(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="calendarWrap position-relative" ref={pickerRef}>
      <div className="pe-1" style={{width:220}}>
        <input
        style={{width:'100%'}}
          type="text"
          className="inputBox input-date form-control"
          placeholder="Select date range"
          readOnly
          onFocus={() => setShowPicker(true)}
          value={
            selectionRange.startDate && selectionRange.endDate
              ? `${formatDate(selectionRange.startDate)} to ${formatDate(selectionRange.endDate)}`
              : ''
          }
        />
      </div>

      {showPicker && (
        <div
          className="border position-absolute bg-white"
          style={{ top: '100%', right: 0 ,zIndex:999}}
          {...props}
        >
          <DateRangePicker
            ranges={[
              {
                ...selectionRange,
                startDate: selectionRange.startDate || new Date(),
                endDate: selectionRange.endDate || new Date(),
              },
            ]}
            onChange={handleSelect}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            months={1}
            direction="horizontal"
            maxDate={new Date()} // disable future dates
          />
        </div>
      )}
    </div>
  );
}
